// #region imports

// --- Angular
import { Component, Input } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-toggle-icon',
  templateUrl: './toggle-icon.component.html',
  styleUrls: ['./toggle-icon.component.scss']
})
export class ToggleIconComponent {

  @Input() primaryIcon: string = '';
  @Input() secondaryIcon: string = '';

  @Input() iconPack: string = 'material';

  private _currentIcon: string = '';

  @Input()
  set active(value: boolean) {
    this._currentIcon = value ? this.primaryIcon : this.secondaryIcon;
  }

  get currentIcon() {
    return this._currentIcon || this.primaryIcon;
  }
}
